// This file was auto-generated by Fern from our API Definition.
export const PrincipalKind = {
    Human: "human",
    ApiKey: "api_key",
    Installation: "installation",
};
